__webpack_require__.p = "/jywebsite/";